import { useCallback, useState } from 'react';
import SubscriptionsRepository from '@/creditflowresearch/infrastructure/repository/SubscriptionsRepository';
import { AlertManager } from '@creditflowresearch/uilib/Alert';
import { getErrorMessage } from '@framework/message/Mapper/getMessage';
import { getContainer } from '@framework/di/getContainer';
import { IUserSubscriptionsResponse } from '@/creditflowresearch/domain/vo/Subscriptions/userSubscriptions';

export const useGetUserSubscriptions = () => {
  const container = getContainer();
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [userSubscriptions, setUserSubscriptions] = useState<IUserSubscriptionsResponse>({});
  const getUserSubscriptions = useCallback(async () => {
    try {
      setIsFetching(true);
      const subscriptionsRepository = container.get(SubscriptionsRepository);
      const response = await subscriptionsRepository.getUserSubscriptionsBySSID();
      setUserSubscriptions(response);
    } catch (error) {
      AlertManager.error(getErrorMessage(error));
    } finally {
      setIsFetching(false);
    }
  }, []);

  return {
    userSubscriptions,
    getUserSubscriptions,
    isFetching,
  };
};
